import { Link, useLocation, useSearchParams } from 'react-router-dom';

export default function SubNav({ items }) {
  const loc = useLocation();
  const [params] = useSearchParams();
  const currentTab = params.get('tab') || '';
  return (
    <nav style={{
      display: 'flex', gap: 4, padding: 4, marginBottom: 22,
      background: 'var(--card-soft)', borderRadius: 12,
      overflowX: 'auto', WebkitOverflowScrolling: 'touch'
    }}>
      {items.map((it) => {
        const [path, qs = ''] = it.to.split('?');
        const itemTab = new URLSearchParams(qs).get('tab') || '';
        const sameRoute = path === loc.pathname || (it.end && loc.pathname === path);
        const active = sameRoute && itemTab === currentTab;
        return (
          <Link
            key={it.to}
            to={it.to}
            replace
            style={{
              padding: '8px 14px', fontSize: 13.5, fontWeight: 600,
              color: active ? 'var(--brand-deep)' : 'var(--text-muted)',
              background: active ? '#fff' : 'transparent',
              borderRadius: 8,
              textDecoration: 'none',
              whiteSpace: 'nowrap',
              transition: 'all 150ms ease',
              boxShadow: active ? 'var(--shadow-card)' : 'none'
            }}
          >{it.label}</Link>
        );
      })}
    </nav>
  );
}
